module.exports = __webpack_public_path__ + "static/media/FT-CEL-CARTON.3531ac78.png";